let allImages = document.querySelectorAll('#t-links tbody .images img');
allImages.forEach((img)=>{
    img.classList.add('hvr-grow');
});

//# sourceMappingURL=enllacos.7ce0730d.js.map
